import _ from 'lodash'
import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class CookieService {

    setLoggedInCookie(): void {
        // used on www.cleverassets.cz for changing header button
        if (_.endsWith(window.location.hostname, 'cleverassets.cz')) {
            const expirationDate = new Date(Date.now() + 2 * 365 * 24 * 60 * 60 * 1000)
            document.cookie = 'loggedAppUser=1; domain=cleverassets.cz; secure; expires=' + expirationDate.toUTCString()
        }
    }
}
